export default (state = {}, action) => {

    switch (action.type) {

    case 'UPDATE_BOOKMARK_VIEW':
    return action.payload;

    default:

    return state;

    }

    };